<template>
    <div class="attr-audio">
        <span class="attr-label">{{ value.label }}</span>
        <div class="attr-audio-player" v-if="audioSrc">
            <div class="attr-audio-icon">
                <i class="fal fa-microphone"></i>
            </div>
            <audio :src="audioSrc" controls class="attr-audio-el"></audio>
            <a :href="audioSrc" download class="attr-audio-dl">
                <i class="fal fa-download text-white"></i>
            </a>
        </div>
        <div v-else class="attr-audio-empty">
            <i class="fal fa-microphone-slash"></i>
            <span>Aucun enregistrement</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AudioAttribute',
    props: ['value', 'medias'],
    computed: {
        audioSrc() {
            if (!this.value || !this.value.value) return null
            const val = this.value.value
            // If it's a media ID (number), build URL from medias
            if (typeof val === 'number' || (typeof val === 'string' && /^\d+$/.test(val))) {
                const media = this.medias ? this.medias.find(m => m.id == val) : null
                if (media) {
                    const baseUrl = this.$store.state.baseURL
                    const token = this.$store.state.auth.token
                    return `${baseUrl}/storage/${media.id}?token=${token}`
                }
            }
            // If it's an array of media IDs
            if (Array.isArray(val) && val.length > 0) {
                const mediaId = val[0]
                const media = this.medias ? this.medias.find(m => m.id == mediaId) : null
                if (media) {
                    const baseUrl = this.$store.state.baseURL
                    const token = this.$store.state.auth.token
                    return `${baseUrl}/storage/${media.id}?token=${token}`
                }
            }
            // If it's already a URL string
            if (typeof val === 'string' && (val.startsWith('http') || val.startsWith('/'))) {
                return val
            }
            return null
        }
    }
}
</script>

<style scoped>
.attr-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 8px;
}

.attr-audio-player {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
}

.attr-audio-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #eff6ff;
    color: #3b82f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    flex-shrink: 0;
}

.attr-audio-el {
    flex: 1;
    min-width: 0;
    height: 36px;
}

.attr-audio-dl {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: #3b82f6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.2s;
}

.attr-audio-dl:hover {
    background: #2563eb;
}

.attr-audio-dl i {
    color: #fff !important;
    font-size: 0.82rem;
}

.attr-audio-empty {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #94a3b8;
    font-size: 0.85rem;
    font-style: italic;
}

.attr-audio-empty i {
    font-size: 1rem;
}
</style>
